import validate from '../../../services/reduxValidate.js'

export default function(data) {
  return validate(data, {
    password: { length: { minimum: 5 }, presence: true },
    repeat_password: {
      equality: {
        attribute: 'password',
        message: 'Les mots de passe saisis ne sont pas identiques'
      },
    }
  })
}